import tokens from '@ifood/pomodoro-tokens';
import styled from 'styled-components';

type ContainerProps = {
  innerPadding: boolean;
};

export const Container = styled.div<ContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;

  ${({ innerPadding = false }): string | false => innerPadding && `padding: 0 ${tokens.space.regular};`}
`;
